/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */


(function() {
    // Add custom code below this line




    // Cart badge counter update
    function updateCartBadge() {
        fetch('/cart.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(data) {
                var count = data.item_count;
                document.querySelectorAll('[data-cart-badge]').forEach(function(badge) {
                    badge.textContent = count;
                });
            });
    }

    document.addEventListener('theme:cart:added', updateCartBadge);
    document.addEventListener('theme:cart:loaded', updateCartBadge);

    // Add click event listeners to all elements with class "product-single__thumbnail"
    const thumbnailElements = document.querySelectorAll('.product-single__thumbnail');

    thumbnailElements.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {

            // Check if the device's width is superior to 768px
            if (window.innerWidth > 768) {
                // Get the data-id attribute value of the clicked thumbnail
                const dataId = thumbnail.getAttribute('data-id');

                // Find the corresponding media slide element with the same data-id
                const mediaSlide = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
                console.log(mediaSlide);

                // Scroll to the media slide element
                if (mediaSlide) {
                    mediaSlide.scrollIntoView({
                        block: "start",
                        behavior: 'smooth'
                    });
                }
            }
        });
    });


    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();